import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { DispatcherData } from '@owc-types/ComponentInitializeDispatcher';
import { isAemEditMode } from '@owc-utils/AEM';

export type AEMMixinProps = {
  datajson: string;
  dataEditMode: boolean;
  dataAemModulename: string;
  dataAemModuletrackingname: string;
};

export type AEMMixinData = Partial<DispatcherData>;

export type AEMMixinComputed = {
  isEditMode: boolean;
};

export const props = {
  dataEditMode: {
    type: Boolean,
    default: false,
  },
  datajson: {
    type: String,
    required: false,
  },
  dataAemModulename: {
    type: String,
    required: false,
  },
  dataAemModuletrackingname: {
    type: String,
    required: false,
  },
};

const mixin: ThisTypedComponentOptionsWithRecordProps<Vue, AEMMixinData, {}, {}, AEMMixinProps> = {
  computed: {
    json: function() {
      if (this.datajson) {
        return JSON.parse(this.datajson);
      }
      return undefined;
    },
    isEditMode() {
      return isAemEditMode(this.$parent);
    },
  },
};

export default mixin;
